<template>
    <b-modal id="group-quote-member-delete" centered>
        <b-button variant="close-btn" @click.prevent="closeModal">
            <i class="fas fa-times"></i>
        </b-button>

        <!-- modal header -->
        <div  class="text-center">
            <h5><strong>Are you sure?</strong></h5>
        </div>

        <!-- modal body -->
        <div class="text-center">
            <p>This member will be permanently removed from the group</p>
            <div class="button-group justify-content-center">
                <b-button class="modal-button cancel-btn" @click="closeModal">Cancel</b-button>
                <b-button class="modal-button delete" @click="deleteMember">Delete</b-button>
            </div>
        </div>
    </b-modal>
</template>


<script>
import Api from '../../../resource/Api';

export default {
    name: "DeleteGroupQuoteMember",

    props: {
        id: {
            type: [Number, String],
            required: true,
        }
    },

    methods: {
        closeModal() {
            this.$bvModal.hide("group-quote-member-delete");
        },
        deleteMember() {
            const url = `v2/quote/delete-groupquote-member?memberId=${this.id}`
            const loader = this.$loading.show();
            Api.delete(url).then((response) => {

                console.log(response);

                if (response.statusText == "OK" || response.status == 200) {
                    this.$bvModal.hide("group-quote-member-delete");
                    this.$notify("Member deleted successfully");
                    this.$store.dispatch('fetchGroupQuotes');
                    // this.$store.commit('setActiveList', 'group');
                }
            }).catch((err) => {
                console.error(err)
                this.$bvModal.hide("group-quote-member-delete");
                this.$notify("Something went wrong!", "error")
            }).finally(() => {
                loader.hide()
            })
        },
    }
}

</script>

<style scoped>
.button-group {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 1.25rem;
    align-items: center;

}

.modal-button {
    padding: .25rem 1.5rem;
    border-radius: .25rem;
    font-weight: 600;
}

.cancel {
    background-color: rgb(119, 119, 119);
    border: 1px solid rgb(88, 88, 88);
}

.delete {
    background-color: rgb(255, 55, 41);
    border: 1px solid rgb(240, 16, 0);
    color: white;
}
</style>